import MovieCard from "../components/MovieCard";
import useFetch from "../hooks/useFetch";
import Loading from "../utils/Loading";
import requests from "../utils/Request";

const Netflix = () => {
  const [data, loading] = useFetch(requests.fetchNetflixOriginals);
  const url = "https://image.tmdb.org/t/p/original/";

  return (
    <div className="bg-gray-900">
      {loading && <Loading />}
      <div className=" sm:w-[90%] sm:ml-auto sm:mr-auto border-gray-800">
        <div className="flex justify-center p-3">
          <h1 className="text-gray-400 font-bold text-2xl">
            Netflix Originals
          </h1>
        </div>
        <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 p-4 mt-5 sm:gap-4 shadow-2xl">
          {data?.map((movie) => (
            <MovieCard
              key={movie.id}
              image={`${url}${movie.poster_path}`}
              title={movie.original_name || movie.title}
              overview={movie.overview}
              vote_average={movie.vote_average}
              release_date={movie.release_date}
              vote_count={movie.vote_count}
              poster_path={`${url}${movie.poster_path}`}
              popularity={movie.popularity}
              media_type={movie.media_type}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Netflix;
